import { render, staticRenderFns } from "./FinanceTags.vue?vue&type=template&id=4ce411ed&scoped=true&"
import script from "./FinanceTags.vue?vue&type=script&lang=js&"
export * from "./FinanceTags.vue?vue&type=script&lang=js&"
import style0 from "./FinanceTags.vue?vue&type=style&index=0&id=4ce411ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce411ed",
  null
  
)

export default component.exports